/**
 * Carries the locked From -> To preset for /convert/<pair> pages to the Converter
 * tool without threading props through the lazy tool registry. Null on every
 * normal tool page, so the converter falls back to its saved preferences.
 */

import { createContext, useContext } from "react";
import type { InputFormat, OutputFormat } from "@/seo/seo.config";

export interface ConvertPreset {
  input: InputFormat;
  output: OutputFormat;
}

export const ConvertPresetContext = createContext<ConvertPreset | null>(null);

export function useConvertPreset(): ConvertPreset | null {
  return useContext(ConvertPresetContext);
}
